module.exports = __webpack_public_path__ + "static/media/kansas.15ca16f4.svg";